import { create } from "zustand";

type Status = "Published" | "Not Published";

interface HookProps {
  filter: Status;
  setFilter: (filter: Status) => void;
}

export const useStatusFilter = create<HookProps>()((set) => ({
  filter: "Published",
  setFilter: (filter) =>
    set(() => ({
      filter,
    })),
}));
